import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '@environments/environment';
import { User } from '@app/_models';
import { headervalue } from 'src/headervalue/header';

const httpOptions = {
    // headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    headers: new HttpHeaders(headervalue.headerWithJwt)
  };

@Injectable({ providedIn: 'root' })
export class UserService {
    constructor(private http: HttpClient) { }

    editUser(formData){
        var temp = this.http.post<any>(`${environment.apiUrl}/user/updateUserById`, formData , httpOptions);
        return temp;
    }

    getUsers() {
        var temp = this.http.get<any>(`${environment.apiUrl}/user/getAllUser`,{ headers:  new HttpHeaders( headervalue.headerWithJwt)  });
        return temp;
      }

    getRoles(){
        var temp = this.http.get<any>(`${environment.apiUrl}/role/getRoleList`,{ headers:  new HttpHeaders( headervalue.headerWithJwt)  });
        return temp;
    }

    addUser(formData){
        var temp = this.http.post<any>(`${environment.apiUrl}/user/addNewUser`, formData , httpOptions);
        return temp;
    }

    deleteUser(id){
        var temp = this.http.delete<any>(`${environment.apiUrl}/user/deleteUser/`+id , httpOptions);
        return temp;
    }
    // getAll() {
    //     //return this.http.get<User[]>(`${environment.apiUrl}/users`, { headers:  new HttpHeaders( headervalue.header)  });
    // }
}